import { Products } from "pages";
import { Modal } from "components";

const App = () => {
  return (
    <>
      <Products />
      <Modal />
    </>
  );
};

export default App;
